import {cloneDeep, get} from "lodash";
import {getString} from "Core/helpers/data";
import {EFaxLogListItemDataObject} from "../dataObjects";
import {getDate, STANDARD_DATE_TIME_FORMAT} from "Core/helpers/datetime";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {EFaxLogListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);
	
	result = new EFaxLogListItemDataObject(
		getString(result, 'id'),
		getString(result, 'reportName'),
		getDate(get(result, 'creationDate', null), STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S),
		getString(result, 'username'),
		getString(result, 'faxNumber'),
		getString(result, 'status'),
		getDate(get(result, 'deliveredDate', null), STANDARD_DATE_TIME_FORMAT.ISO_DATE_TIME_S),
	);

	return result;
}

// @note: There is no output function since list is read-only.